module.exports = __webpack_public_path__ + "static/img/img_logo.08a61a86.png";